import React from 'react';
import { Global } from '@emotion/react';
import { MediaQueryProvider } from 'react-media-query-hoc';
import * as styles from './landing-page-2026.style';
import useLandingPageTracking from './hooks/use-landing-page-tracking';
import UltimateGuide2026 from './components/ultimate-guide/ultimate-guide-2026';
import CallToActions2026 from './components/call-to-actions/call-to-actions-2026';
import type { LandingPageProps } from './landing-page';
import LandingPageBanner2026 from './components/landing-page-banner-2026';

const LandingPage2026 = ({
  skipLinkContentId,
  mixpanelHasInitialized = false,
  showCallToActions = true,
  showUltimateGuide = true,
  showSuburbSnapshot = false,
}: LandingPageProps): JSX.Element => {
  const { onModuleRendered } = useLandingPageTracking({
    mixpanelHasInitialized,
    showCallToActions,
    showUltimateGuide,
    showSuburbSnapshot,
  });

  return (
    <MediaQueryProvider values={{ width: 300, type: 'screen' }}>
      <div css={styles.container} data-theme-name="domain-2022">
        <Global styles={styles.globalStyle} />
        <LandingPageBanner2026
          skipLinkContentId={skipLinkContentId}
          styles={styles}
        />
        <div css={styles.page}>
          {showCallToActions && (
            <div css={styles.callToActions}>
              <div css={styles.callToActionsWrapper}>
                <CallToActions2026 onModuleRendered={onModuleRendered} />
              </div>
            </div>
          )}
          {showUltimateGuide && (
            <div css={styles.ultimateGuides}>
              <div css={styles.wrapper}>
                <UltimateGuide2026 onModuleRendered={onModuleRendered} />
              </div>
            </div>
          )}
          {showSuburbSnapshot && (
            <div css={styles.wrapper} data-testid="suburb-snapshot-module" />
          )}
        </div>
      </div>
    </MediaQueryProvider>
  );
};

export default LandingPage2026;
